export const SERVICE_FAVORITE = 'SERVICE_FAVORITE';
export const SERVICE_FAVORITE_SUCCESS = 'SERVICE_FAVORITE_SUCCESS';
export const SERVICE_FAVORITE_ERROR = 'SERVICE_FAVORITE_ERROR';
export const SERVICE_TRASH = 'SERVICE_TRASH';
export const SERVICE_TRASH_SUCCESS = 'SERVICE_TRASH_SUCCESS';
export const SERVICE_TRASH_ERROR = 'SERVICE_TRASH_ERROR';
export const SERVICE_FILTER_UPDATE = 'SERVICE_FILTER_UPDATE';
export const SERVICE_FILTER_UPDATE_NO_FETCH = 'SERVICE_FILTER_UPDATE_NO_FETCH';
export const SERVICE_FILTER_SUCCESS = 'SERVICE_FILTER_SUCCESS';
export const SERVICE_FILTER_ERROR = 'SERVICE_FILTER_ERROR';
export const SERVICE_FILTER_RESET = 'SERVICE_FILTER_RESET';
export const SERVICE_UPDATE_ID = 'SERVICE_UPDATE_ID';
export const SERVICE_UPDATE_CART_ID = 'SERVICE_UPDATE_CART_ID';
export const SERVICE_USE_FREE_LEAD = 'SERVICE_USE_FREE_LEAD';
export const SERVICE_USE_FREE_LEAD_ERROR = 'SERVICE_USE_FREE_LEAD_ERROR';
export const SERVICE_USE_FREE_LEAD_SUCCESS = 'SERVICE_USE_FREE_LEAD_SUCCESS';
export const SERVICE_LOAD_MORE_ERROR = 'SERVICE_LOAD_MORE_ERROR';
export const SERVICE_LOAD_MORE_SUCCESS = 'SERVICE_LOAD_MORE_SUCCESS';
export const JOB_LOADING = 'JOB_LOADING';
export const JOB_SUCCESS = 'JOB_SUCCESS';
export const JOB_ERROR = 'JOB_ERROR';
export const JOB_UNAVAILABLE = 'JOB_UNAVAILABLE';
export const JOB_RESET = 'JOB_RESET';
export const RELEVANT_JOBS = 'RELEVANT_JOBS';
export const RELEVANT_JOBS_SUCCESS = 'RELEVANT_JOBS_SUCCESS';
export const RELEVANT_JOBS_ERROR = 'RELEVANT_JOBS_ERROR';
